import { debounce } from 'lodash'
import { IDB_lastActivity } from '../IDB/IDB.dexie'

export const Evnt_onActivity = debounce(() => IDB_lastActivity().set(new Date()), 400)
